module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "confirm-form"
  }, [_c('h5', {
    staticClass: "text-center"
  }, [_vm._v("選擇退藥理由")]), _vm._v(" "), _c('div', {
    staticClass: "reasons-wrap"
  }, _vm._l((_vm.returnReasons), function(reason, n) {
    return _c('div', {
      class: {
        'btn drug-button': true, 'item-selected': _vm.selectReason === reason, 'reason-button': true
      },
      on: {
        "click": function($event) {
          return _vm.setReason(reason)
        }
      }
    }, [_vm._v("\n      " + _vm._s(reason) + "\n    ")])
  }), 0), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "0"
    }
  }, [_c('h6', {
    staticClass: "col-3 col-form-label"
  }, [_vm._v("其他")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customReason),
      expression: "customReason"
    }],
    staticClass: "col-9 form-control",
    attrs: {
      "type": "text",
      "placeholder": "自訂理由"
    },
    domProps: {
      "value": (_vm.customReason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customReason = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "button-wrap"
  }, [_c('button', {
    staticClass: "btn confirm-button btn-lg",
    on: {
      "click": _vm.confirmReason
    }
  }, [_vm._v("確認理由")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74894930","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/flowComp/Reason.vue
// module id = 1509
// module chunks = 1